import { Box, Typography, useTheme } from "@mui/material";
import { t } from "i18next";

import { ScoreChart } from "src/components/ScoreChart/ScoreChart";

import { useScoreChartData } from "./hooks/useScoreChartData";

export type ScoreChartBlockProps = {
    scoreId?: number | null;
    variationId?: string | null;
};

export const ScoreChartBlock = (props: ScoreChartBlockProps) => {
    const theme = useTheme();
    const { formattedData, isLoading, hasScore } = useScoreChartData(props);

    if (!hasScore) {
        return (
            <Box
                sx={{
                    p: theme.spacing(3),
                    textAlign: "center",
                }}
            >
                <Typography>{t("score.notSelected", "No score selected")}</Typography>
            </Box>
        );
    }

    if (!formattedData) {
        return null;
    }

    const { chartData, displayScore, selectedScoreEntity } = formattedData;

    return (
        <ScoreChart
            data={chartData}
            totalScore={displayScore}
            allScoreWithVariations={[]}
            selectedScore={{
                ...selectedScoreEntity,
                onClick: () => {},
                group: "",
            }}
            isLoading={isLoading}
            disableVariations={true}
            withVariation={false}
            withLegend={false}
        />
    );
};
